<template>
  <div class="card" v-if="tmpType == 1">
    <div class="card-title">推荐门店</div>
    <div class="card-content">
      <div class="left">
        <div class="store-name">
          <i class="el-icon-s-shop"></i>
          <span>成都市青羊区光华直营店</span>  
        </div>
        <div class="store-addr">四川省成都市青羊区光华北三路98号</div>
      </div>
      <div class="right">
        <i class="el-icon-phone"></i>
        <div>电话</div>
      </div>
    </div>
    <div class="card-footer">更多门店>>></div>
  </div>
  <div v-else>
    <img style="width: 100%;height: 100%" :src="imgList[tmpType-2]" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    tmpType: String,
  },
  data() {
    return {
      imgList: [
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C1/rB8LrmUuAFWAKkRGAAFedt66GZE336.png',
        require('@/assets/images/styleTwo/store.png'),
        require('@/assets/images/styleFour/md.png'),
        require('@/assets/images/styleFive/hdmd.png'),
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  box-sizing: border-box
  background: linear-gradient(#FFE8DF, #FFB892);
  padding: 5px 0
  margin 15px
  border-radius: 12px
  &-title
    padding 10px 0
    text-align: center
    font-size 22px
    font-weight bold
    color #EC2F30
  &-content
    margin 0 5px 5px
    padding 10px
    background: #FFF0EA
    border-radius: 5px
    display: flex
    .left
      flex 1
      .store-name
        padding 5px 0
        font-size 15px
        color #333
        span
          margin-left 5px
          font-weight bold
      .store-addr
        padding 5px 0
        color #666
    .right
      flex none
      align-self: center
      text-align: center
      width 50px
      color #FF6B31
  &-footer
    margin 10px 0 5px
    text-align: center
    color #EC2F30
</style>